import axios from "axios";

const SETTINGS_URL =
  `${process.env.REACT_APP_API_URL}/inscricoes` ||
  "http://localhost:3001/api/inscricoes";

export async function getInscricoes(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(SETTINGS_URL, { headers });
  return response.data;
}
